/**
 * @name Ua.js
 */

export class Ua {
    constructor() {
        this.body = document.body;
        this.bodyClassList = this.body.classList;
        this.ua = window.navigator.userAgent.toLowerCase();
        this.data = {
            browser: "",
            os: "",
            device: "",
            iphone: "",
            driver: "",
            driverSpec: "",
            cpu: "",
        };

        this.checkBrowser();
        this.checkOs();
        this.checkDevice();
        this.checkiPhone();
        this.checkDriver();
        this.checkCpu();
    }

    checkBrowser() {
        if (this.ua.indexOf("edge") !== -1 || this.ua.indexOf("edga") !== -1 || this.ua.indexOf("edgios") !== -1) {
            MODE && console.log("⚙️ ~ This is Edge");
            this.data.browser = "edge";
        } else if (this.ua.indexOf("opera") !== -1 || this.ua.indexOf("opr") !== -1) {
            MODE && console.log("⚙️ ~ This is Opera");
            this.data.browser = "opera";
        } else if (this.ua.indexOf("samsungbrowser") !== -1) {
            MODE && console.log("⚙️ ~ This is SamsungInternetBrowser");
            this.data.browser = "samsung";
        } else if (this.ua.indexOf("ucbrowser") !== -1) {
            MODE && console.log("⚙️ ~ This is UcBrowser");
            this.data.browser = "uc";
        } else if (this.ua.indexOf("chrome") !== -1 || this.ua.indexOf("crios") !== -1) {
            MODE && console.log("⚙️ ~ This is Chrome");
            this.data.browser = "chrome";
        } else if (this.ua.indexOf("firefox") !== -1 || this.ua.indexOf("fxios") !== -1) {
            MODE && console.log("⚙️ ~ This is Firefox");
            this.data.browser = "firefox";
        } else if (this.ua.indexOf("safari") !== -1) {
            MODE && console.log("⚙️ ~ This is Safari");
            this.data.browser = "safari";
        } else if (this.ua.indexOf("msie") !== -1 || this.ua.indexOf("trident") !== -1) {
            MODE && console.log("⚙️ ~ This is IE");
            this.data.browser = "ie";
            alert("このブラウザは現在サポートされておりません。");
        } else {
            MODE && console.log("⚙️ ~ This is An unknown browser");
            this.data.browser = "";
        }

        // if (this.data.browser != "") this.bodyClassList.add(this.data.browser);
    }

    checkOs() {
        if (this.ua.indexOf("windows nt") !== -1) {
            MODE && console.log("⚙️ ~ This is Windows");
            this.data.os = "windows";
        } else if (this.ua.indexOf("android") !== -1) {
            MODE && console.log("⚙️ ~ This is Android");
            this.data.os = "android";
        } else if (this.ua.indexOf("iphone") !== -1 || this.ua.indexOf("ipad") !== -1) {
            MODE && console.log("⚙️ ~ This is iOS");
            this.data.os = "ios";
        } else if (this.ua.indexOf("mac os x") !== -1) {
            MODE && console.log("⚙️ ~ This is macOS");
            this.data.os = "macos";
        } else {
            MODE && console.log("⚙️ ~ This is An unknown OS");
            this.data.os = "";
        }

        // if (this.data.os != "") this.bodyClassList.add(this.data.os);
    }

    checkDevice() {
        if (this.ua.indexOf("iphone") !== -1 || (this.ua.indexOf("android") !== -1 && this.ua.indexOf("Mobile") > 0)) {
            MODE && console.log("⚙️ ~ This is Mobile");
            this.data.device = "mobile";
        } else if (this.ua.indexOf("ipad") !== -1 || this.ua.indexOf("android") !== -1) {
            MODE && console.log("⚙️ ~ This is Tablet");
            this.data.device = "tablet";
        } else if (this.ua.indexOf("ipad") > -1 || (this.ua.indexOf("macintosh") > -1 && "ontouchend" in document)) {
            MODE && console.log("⚙️ ~ This is iPad");
            this.data.device = "tablet";
        } else {
            MODE && console.log("⚙️ ~ This is PC");
            this.data.device = "pc";
        }

        // if (this.data.device != "") this.bodyClassList.add(this.data.device);
    }

    checkiPhone() {
        if (this.ua.indexOf("iphone") !== -1) {
            MODE && console.log("⚙️ ~ This is iPhone");
            this.data.iphone = "iphone";
        } else {
            this.data.iphone = "";
        }

        // if (this.data.iphone != "") this.bodyClassList.add(this.data.iphone);
    }

    checkDriver() {
        let canvas = document.createElement('canvas');
        let gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

        if (!gl) {
            MODE && console.log("⚙️ ~ WebGL not supported");
            this.data.driver = "unknown";
            return;
        }

        let debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        let renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        let vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);

        // Intel GPU
        if (vendor.indexOf('Intel') !== -1 || renderer.indexOf('HD Graphics') !== -1) {
            MODE && console.log("⚙️ ~ This is Intel GPU");
            this.data.driver = "intel";
        } else if (vendor.indexOf('NVIDIA') !== -1 && (renderer.indexOf('GeForce GT') !== -1 || renderer.indexOf('GeForce GTS') !== -1 || renderer.indexOf('GeForce 8') !== -1 || renderer.indexOf('GeForce 9') !== -1)) {
            MODE && console.log("⚙️ ~ This is NVIDIA GPU");
            this.data.driver = "nvidia";
        } else if ((vendor.indexOf('ATI') !== -1 || vendor.indexOf('AMD') !== -1) && (renderer.indexOf('Radeon HD') !== -1 || renderer.indexOf('Radeon R5') !== -1 || renderer.indexOf('Radeon R7') !== -1)) {
            MODE && console.log("⚙️ ~ This is AMD GPU");
            this.data.driver = "amd";
        } else {
            MODE && console.log("⚙️ ~ This is an unknown or unsupported driver");
            this.data.driver = "unknown";
        }

        // 新しいGPUか古いGPUか
        if (renderer.indexOf('Intel HD Graphics 3000') !== -1 ||
            renderer.indexOf('Intel HD Graphics 4000') !== -1 ||
            renderer.indexOf('GeForce 8600') !== -1 ||
            renderer.indexOf('Radeon HD 4000') !== -1 ||
            renderer.indexOf('Adreno 205') !== -1 ||
            renderer.indexOf('Mali-400') !== -1) {
            // 古いGPUと判断
            MODE && console.log("⚙️ ~ This is an old GPU");
            this.data.driverSpec = "old";
        } else {
            MODE && console.log("⚙️ ~ This is a modern GPU");
            this.data.driverSpec = "modern";
        }

        // if (this.data.driver != "") this.bodyClassList.add(this.data.driver);
    }

    checkCpu() {
        let cores = navigator.hardwareConcurrency;

        if (cores && cores < 4) {
            MODE && console.log("⚙️ ~ This is a low core CPU");
            this.data.cpu = cores;
        } else {
            MODE && console.log("⚙️ ~ This is a high core CPU");
            this.data.cpu = cores;
        }
    }
}